// @flow

import type { Action } from './store.type';

export const VERIFY_DISCOUNT_CODE_REQUEST = 'VERIFY_DISCOUNT_CODE_V5_REQUEST';
type VERIFY_DISCOUNT_CODE_REQUEST_TYPE = 'VERIFY_DISCOUNT_CODE_V5_REQUEST';

export const VERIFY_DISCOUNT_CODE_SUCCESS = 'VERIFY_DISCOUNT_CODE_V5_SUCCESS';
type VERIFY_DISCOUNT_CODE_SUCCESS_TYPE = 'VERIFY_DISCOUNT_CODE_V5_SUCCESS';

export const VERIFY_DISCOUNT_CODE_FAILURE = 'VERIFY_DISCOUNT_CODE_V5_FAILURE';
type VERIFY_DISCOUNT_CODE_FAILURE_TYPE = 'VERIFY_DISCOUNT_CODE_V5_FAILURE';

export const SUBSCRIBE_PLAN_REQUEST = 'SUBSCRIBE_PLAN_V5_REQUEST';
type SUBSCRIBE_PLAN_REQUEST_TYPE = 'SUBSCRIBE_PLAN_V5_REQUEST';

export const SUBSCRIBE_PLAN_SUCCESS = 'SUBSCRIBE_PLAN_V5_SUCCESS';
type SUBSCRIBE_PLAN_SUCCESS_TYPE = 'SUBSCRIBE_PLAN_V5_SUCCESS';

export const SUBSCRIBE_PLAN_FAILURE = 'SUBSCRIBE_PLAN_V5_FAILURE';
type SUBSCRIBE_PLAN_FAILURE_TYPE = 'SUBSCRIBE_PLAN_V5_FAILURE';

export const ACTIVATE_CHARGE_REQUEST = 'ACTIVATE_CHARGE_V5_REQUEST';
type ACTIVATE_CHARGE_REQUEST_TYPE = 'ACTIVATE_CHARGE_V5_REQUEST';

export const ACTIVATE_CHARGE_SUCCESS = 'ACTIVATE_CHARGE_V5_SUCCESS';
type ACTIVATE_CHARGE_SUCCESS_TYPE = 'ACTIVATE_CHARGE_V5_SUCCESS';

export const ACTIVATE_CHARGE_FAILURE = 'ACTIVATE_CHARGE_V5_FAILURE';
type ACTIVATE_CHARGE_FAILURE_TYPE = 'ACTIVATE_CHARGE_V5_FAILURE';

export const CLEAR_DISCOUNT_CODE = 'CLEAR_DISCOUNT_V5_CODE';
type CLEAR_DISCOUNT_CODE_TYPE = 'CLEAR_DISCOUNT_V5_CODE';

export const GET_GMV_LIMIT_REQUEST = 'GET_GMV_LIMIT_REQUEST';
type GET_GMV_LIMIT_REQUEST_TYPE = 'GET_GMV_LIMIT_REQUEST';

export const GET_GMV_LIMIT_SUCCESS = 'GET_GMV_LIMIT_SUCCESS';
type GET_GMV_LIMIT_SUCCESS_TYPE = 'GET_GMV_LIMIT_SUCCESS';

export const GET_GMV_LIMIT_FAILURE = 'GET_GMV_LIMIT_FAILURE';
type GET_GMV_LIMIT_FAILURE_TYPE = 'GET_GMV_LIMIT_FAILURE';

export const VALIDATE_GMV_LIMIT_REQUEST = 'VALIDATE_GMV_LIMIT_REQUEST';
type VALIDATE_GMV_LIMIT_REQUEST_TYPE = 'VALIDATE_GMV_LIMIT_REQUEST';

export const VALIDATE_GMV_LIMIT_SUCCESS = 'VALIDATE_GMV_LIMIT_SUCCESS';
type VALIDATE_GMV_LIMIT_SUCCESS_TYPE = 'VALIDATE_GMV_LIMIT_SUCCESS';

export const VALIDATE_GMV_LIMIT_FAILURE = 'VALIDATE_GMV_LIMIT_FAILURE';
type VALIDATE_GMV_LIMIT_FAILURE_TYPE = 'VALIDATE_GMV_LIMIT_FAILURE';

export const GET_GMV_LIMIT_PLANS_REQUEST = 'GET_GMV_LIMIT_PLANS_REQUEST';
type GET_GMV_LIMIT_PLANS_REQUEST_TYPE = 'GET_GMV_LIMIT_PLANS_REQUEST';

export const GET_GMV_LIMIT_PLANS_SUCCESS = 'GET_GMV_LIMIT_PLANS_SUCCESS';
type GET_GMV_LIMIT_PLANS_SUCCESS_TYPE = 'GET_GMV_LIMIT_PLANS_SUCCESS';

export const GET_GMV_LIMIT_PLANS_FAILURE = 'GET_GMV_LIMIT_PLANS_FAILURE';
type GET_GMV_LIMIT_PLANS_FAILURE_TYPE = 'GET_GMV_LIMIT_PLANS_FAILURE';

export const GET_GMV_LIMIT_PLANS_BY_TYPE_REQUEST = 'GET_GMV_LIMIT_PLANS_BY_TYPE_REQUEST';
type GET_GMV_LIMIT_PLANS_BY_TYPE_REQUEST_TYPE = 'GET_GMV_LIMIT_PLANS_BY_TYPE_REQUEST';

export const GET_GMV_LIMIT_PLANS_BY_TYPE_SUCCESS = 'GET_GMV_LIMIT_PLANS_BY_TYPE_SUCCESS';
type GET_GMV_LIMIT_PLANS_BY_TYPE_SUCCESS_TYPE = 'GET_GMV_LIMIT_PLANS_BY_TYPE_SUCCESS';

export const GET_GMV_LIMIT_PLANS_BY_TYPE_FAILURE = 'GET_GMV_LIMIT_PLANS_BY_TYPE_FAILURE';
type GET_GMV_LIMIT_PLANS_BY_TYPE_FAILURE_TYPE = 'GET_GMV_LIMIT_PLANS_BY_TYPE_FAILURE';

export const GET_GMV_MIGRATION_STORES_REQUEST = 'GET_GMV_MIGRATION_STORES_REQUEST';
type GET_GMV_MIGRATION_STORES_REQUEST_TYPE = 'GET_GMV_MIGRATION_STORES_REQUEST';

export const GET_GMV_MIGRATION_STORES_SUCCESS = 'GET_GMV_MIGRATION_STORES_SUCCESS';
type GET_GMV_MIGRATION_STORES_SUCCESS_TYPE = 'GET_GMV_MIGRATION_STORES_SUCCESS';

export const GET_GMV_MIGRATION_STORES_FAILURE = 'GET_GMV_MIGRATION_STORES_FAILURE';
type GET_GMV_MIGRATION_STORES_FAILURE_TYPE = 'GET_GMV_MIGRATION_STORES_FAILURE';

// gmv billing history
export const GET_GMV_BILLING_HISTORY_REQUEST = 'GET_GMV_BILLING_HISTORY_V5_REQUEST';
type GET_GMV_BILLING_HISTORY_REQUEST_TYPE = 'GET_GMV_BILLING_HISTORY_V5_REQUEST';

export const GET_GMV_BILLING_HISTORY_SUCCESS = 'GET_GMV_BILLING_HISTORY_V5_SUCCESS';
type GET_GMV_BILLING_HISTORY_SUCCESS_TYPE = 'GET_GMV_BILLING_HISTORY_V5_SUCCESS';

export const GET_GMV_BILLING_HISTORY_FAILURE = 'GET_GMV_BILLING_HISTORY_V5_FAILURE';
type GET_GMV_BILLING_HISTORY_FAILURE_TYPE = 'GET_GMV_BILLING_HISTORY_V5_FAILURE';

export const EXPORT_GMV_BILLING_HISTORY_REQUEST = 'EXPORT_GMV_BILLING_HISTORY_V5_REQUEST';
type EXPORT_GMV_BILLING_HISTORY_REQUEST_TYPE = 'EXPORT_GMV_BILLING_HISTORY_V5_REQUEST';

export const EXPORT_GMV_BILLING_HISTORY_SUCCESS = 'EXPORT_GMV_BILLING_HISTORY_V5_SUCCESS';
type EXPORT_GMV_BILLING_HISTORY_SUCCESS_TYPE = 'EXPORT_GMV_BILLING_HISTORY_V5_SUCCESS';

export const EXPORT_GMV_BILLING_HISTORY_FAILURE = 'EXPORT_GMV_BILLING_HISTORY_V5_FAILURE';
type EXPORT_GMV_BILLING_HISTORY_FAILURE_TYPE = 'EXPORT_GMV_BILLING_HISTORY_V5_FAILURE';

// invoice plan
export const GET_INVOICE_PLAN_REQUEST = 'GET_INVOICE_PLAN_V5_REQUEST';
type GET_INVOICE_PLAN_REQUEST_TYPE = 'GET_INVOICE_PLAN_V5_REQUEST';

export const GET_INVOICE_PLAN_SUCCESS = 'GET_INVOICE_PLAN_V5_SUCCESS';
type GET_INVOICE_PLAN_SUCCESS_TYPE = 'GET_INVOICE_PLAN_V5_SUCCESS';

export const GET_INVOICE_PLAN_FAILURE = 'GET_INVOICE_PLAN_V5_FAILURE';
type GET_INVOICE_PLAN_FAILURE_TYPE = 'GET_INVOICE_PLAN_V5_FAILURE';

export const STORE_CURRENT_ROUTE_SUCCESS = 'STORE_CURRENT_ROUTE_SUCCESS';
type STORE_CURRENT_ROUTE_SUCCESS_TYPE = 'STORE_CURRENT_ROUTE_SUCCESS';

type SubscriptionSuccess = {
  data: Object
};

type SubscriptionFailure = {
  error: any
};

// Verify discount code
type VerifyDiscountCodeRequestAction = Action<VERIFY_DISCOUNT_CODE_REQUEST_TYPE, null>;

type VerifyDiscountCodeSuccessAction = Action<
  VERIFY_DISCOUNT_CODE_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type VerifyDiscountCodeFailureAction = Action<
  VERIFY_DISCOUNT_CODE_FAILURE_TYPE,
  SubscriptionFailure
>;

// Subscribe plan
type SubscribePlanRequestAction = Action<SUBSCRIBE_PLAN_REQUEST_TYPE, null>;

type SubscribePlanSuccessAction = Action<SUBSCRIBE_PLAN_SUCCESS_TYPE, SubscriptionSuccess>;

type SubscribePlanFailureAction = Action<SUBSCRIBE_PLAN_FAILURE_TYPE, SubscriptionFailure>;

// Active charge
type ActivateChargeRequestAction = Action<ACTIVATE_CHARGE_REQUEST_TYPE, null>;

type ActivateChargeSuccessAction = Action<ACTIVATE_CHARGE_SUCCESS_TYPE, SubscriptionSuccess>;

type ActivateChargeFailureAction = Action<ACTIVATE_CHARGE_FAILURE_TYPE, SubscriptionFailure>;

type ClearDiscountCodeAction = Action<CLEAR_DISCOUNT_CODE_TYPE, null>;

// Gmv

type GetGMVLimitRequestAction = Action<GET_GMV_LIMIT_REQUEST_TYPE, null>;

type GetGMVLimitSuccessAction = Action<GET_GMV_LIMIT_SUCCESS_TYPE, SubscriptionSuccess>;

type GetGMVLimitFailureAction = Action<GET_GMV_LIMIT_FAILURE_TYPE, SubscriptionFailure>;

type ValidateGMVLimitRequestAction = Action<VALIDATE_GMV_LIMIT_REQUEST_TYPE, null>;

type ValidateGMVLimitSuccessAction = Action<VALIDATE_GMV_LIMIT_SUCCESS_TYPE, SubscriptionSuccess>;

type ValidateGMVLimitFailureAction = Action<VALIDATE_GMV_LIMIT_FAILURE_TYPE, SubscriptionFailure>;

type GetGMVLimitPlansRequestAction = Action<GET_GMV_LIMIT_PLANS_REQUEST_TYPE, null>;

type GetGMVLimitPlansSuccessAction = Action<GET_GMV_LIMIT_PLANS_SUCCESS_TYPE, SubscriptionSuccess>;

type GetGMVLimitPlansFailureAction = Action<GET_GMV_LIMIT_PLANS_FAILURE_TYPE, SubscriptionFailure>;

type GetGMVLimitPlansByTypeRequestAction = Action<GET_GMV_LIMIT_PLANS_BY_TYPE_REQUEST_TYPE, null>;

type GetGMVLimitPlansByTypeSuccessAction = Action<
  GET_GMV_LIMIT_PLANS_BY_TYPE_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type GetGMVLimitPlansByTypeFailureAction = Action<
  GET_GMV_LIMIT_PLANS_BY_TYPE_FAILURE_TYPE,
  SubscriptionFailure
>;

type GetGMVMigrationStoresRequestAction = Action<GET_GMV_MIGRATION_STORES_REQUEST_TYPE, null>;

type GetGMVMigrationStoresSuccessAction = Action<
  GET_GMV_MIGRATION_STORES_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type GetGMVMigrationStoresFailureAction = Action<
  GET_GMV_MIGRATION_STORES_FAILURE_TYPE,
  SubscriptionFailure
>;

// Billing history
type GetGMVBillingHistoryRequestAction = Action<GET_GMV_BILLING_HISTORY_REQUEST_TYPE, null>;

type GetGMVBillingHistorySuccessAction = Action<
  GET_GMV_BILLING_HISTORY_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type GetGMVBillingHistoryFailureAction = Action<
  GET_GMV_BILLING_HISTORY_FAILURE_TYPE,
  SubscriptionFailure
>;

type ExportGMVBillingHistoryRequestAction = Action<EXPORT_GMV_BILLING_HISTORY_REQUEST_TYPE, null>;

type ExportGMVBillingHistorySuccessAction = Action<
  EXPORT_GMV_BILLING_HISTORY_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type ExportGMVBillingHistoryFailureAction = Action<
  EXPORT_GMV_BILLING_HISTORY_FAILURE_TYPE,
  SubscriptionFailure
>;

// Invoice plan
type GetInvoicePlanRequestAction = Action<GET_INVOICE_PLAN_REQUEST_TYPE, null>;

type GetInvoicePlanSuccessAction = Action<GET_INVOICE_PLAN_SUCCESS_TYPE, SubscriptionSuccess>;

type GetInvoicePlanFailureAction = Action<GET_INVOICE_PLAN_FAILURE_TYPE, SubscriptionFailure>;
// Store current route for back
type StoreCurrentRouteSuccessAction = Action<STORE_CURRENT_ROUTE_SUCCESS_TYPE, SubscriptionSuccess>;

export type SubscriptionAction =
  | VerifyDiscountCodeRequestAction
  | VerifyDiscountCodeSuccessAction
  | VerifyDiscountCodeFailureAction
  | SubscribePlanRequestAction
  | SubscribePlanSuccessAction
  | SubscribePlanFailureAction
  | ActivateChargeRequestAction
  | ActivateChargeSuccessAction
  | ActivateChargeFailureAction
  | ClearDiscountCodeAction
  | GetGMVLimitRequestAction
  | GetGMVLimitSuccessAction
  | GetGMVLimitFailureAction
  | GetGMVLimitPlansRequestAction
  | GetGMVLimitPlansSuccessAction
  | GetGMVLimitPlansFailureAction
  | ValidateGMVLimitRequestAction
  | ValidateGMVLimitSuccessAction
  | ValidateGMVLimitFailureAction
  | GetGMVLimitPlansByTypeRequestAction
  | GetGMVLimitPlansByTypeSuccessAction
  | GetGMVLimitPlansByTypeFailureAction
  | GetGMVMigrationStoresRequestAction
  | GetGMVMigrationStoresSuccessAction
  | GetGMVMigrationStoresFailureAction
  | GetGMVBillingHistoryRequestAction
  | GetGMVBillingHistorySuccessAction
  | GetGMVBillingHistoryFailureAction
  | GetInvoicePlanRequestAction
  | GetInvoicePlanSuccessAction
  | GetInvoicePlanFailureAction
  | ExportGMVBillingHistoryRequestAction
  | ExportGMVBillingHistorySuccessAction
  | ExportGMVBillingHistoryFailureAction
  | StoreCurrentRouteSuccessAction;

export type SubscriptionState = {
  subscribing: boolean,
  loading: boolean,
  unsubscribing: boolean,
  activating: boolean,
  subscribeSuccess: boolean,
  success: boolean,
  error?: any,
  confirmationUrl?: string,
  remainCycles: number,
  migrateESCluster: boolean,

  // discount
  termsConditions: string,
  verifying: boolean,
  msgError: ?string,

  // get current base gmv
  gettingBaseGMV: boolean,
  getGMVLimitSuccess: boolean,
  baseGMV: Object,

  // get plans
  gettingPlans: boolean,
  getPlansSuccess: boolean,
  gettingMigrationStores: boolean,
  migrationStores: Array<string>,
  plans: {
    launch: Array<any>,
    convert: Array<any>,
    accelerate: Array<any>,
    enterprise: Array<any>
  },
  // invoice
  gettingInvoice: boolean,
  getInvoiceSuccess: boolean,
  invoice: Object
};
